import { render, staticRenderFns } from "./GallerySmall.vue?vue&type=template&id=0cd1a32a&scoped=true"
import script from "./GallerySmall.vue?vue&type=script&lang=js"
export * from "./GallerySmall.vue?vue&type=script&lang=js"
import style0 from "./GallerySmall.vue?vue&type=style&index=0&id=0cd1a32a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd1a32a",
  null
  
)

export default component.exports